import React, { useMemo } from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { TabComponent } from '@sde/widgets-core/src/common/TabComponent';
import { usePPDLagoon } from '@sde/widgets-core/src/tools/lagoon';
import { RightRailSubCard } from 'src/common/RightRailSubCard';
import { getDomain } from '@web/tools/getDomain';
import PropTypes from 'prop-types';
import { usePayers } from '@sde/widgets-core/src/redux/resources/payers';

const Divider = styled('div', {
  width: '100%',
  borderBottom: '1px solid $gray4',
  marginBottom: '10px',
});

const props = {
  unreadInfoPosition: 'initial',
  isEditable: true,
  isMinified: true,
};

const homePageContentsLagoonMap = [
  'DOCUMENTSTOOLRESOURCES',
  'DOCUMENTSINTERACTIVETRAININGGUIDE',
  'REPORTSANDQUALITYPROGRAMS',
];

const headerContentsLagoonMap = [
  'REPORTCENTER',
  'PHYSICIANPERFORMANDANDREPORTING',
  'UNITEDHEALTHCARECOMMUNITYCARE',
  'UNITEDHEALTHCAREWESTREPORTS',
];

const DocumentsLinks = React.memo(({ user, toggleModal }) => {
  const { getHomePageContentsByArrayOfKeys, getHeaderContentsByArrayOfKeys } =
    usePPDLagoon();

  // Memoize the links for efficiency
  const mainLinks = useMemo(
    () => getHomePageContentsByArrayOfKeys(homePageContentsLagoonMap),
    [getHomePageContentsByArrayOfKeys]
  );
  const quickLinks = useMemo(
    () => getHeaderContentsByArrayOfKeys(headerContentsLagoonMap),
    [getHeaderContentsByArrayOfKeys]
  );

  return (
    <React.Fragment>
      <Flex
        style={{ height: '45%', padding: '0px 24px' }}
        direction="column"
        justify="space-evenly"
      >
        <RightRailSubCard
          railHeader="Documents & Reporting Resources"
          railLinks={mainLinks}
          user={user}
        />
      </Flex>
      <Divider />
      <Flex
        style={{ height: '53%', padding: '0px 24px' }}
        direction="column"
        justify="space-evenly"
      >
        <RightRailSubCard
          railHeader="Quick Links & Tools"
          railLinks={quickLinks}
          hideDivider
          toggleModal={toggleModal}
          user={user}
        />
      </Flex>
    </React.Fragment>
  );
});

export const documentsRightRail = (user, toggleModal) => [
  <DocumentsLinks user={user} toggleModal={toggleModal} />,
];

const DocumentsMainContents = ({ user, provider, payer }) => {
  const { payers } = usePayers.state();
  const docLibDomain = getDomain('sde-documentlibrary', 3500);

  return (
    <abyss-parcel
      scriptdomain={docLibDomain}
      user={JSON.stringify(user)}
      provider={JSON.stringify(provider)}
      import="doclib-recently-added-widget@dev"
      props={JSON.stringify(props)}
      label="Documents Tab"
      showLoading={JSON.stringify(true)}
      loadingStyles={JSON.stringify({ position: 'initial' })}
      payer={JSON.stringify(payer)}
      payers={JSON.stringify(payers)}
    />
  );
};

export const DocumentsTab = ({ user, provider, toggleModal, payer }) => {
  return (
    <TabComponent
      component={
        <DocumentsMainContents user={user} provider={provider} payer={payer} />
      }
      rightRails={documentsRightRail(user, toggleModal)}
      tabName="Documents & Reporting"
    />
  );
};

DocumentsTab.propTypes = {
  user: PropTypes.objectOf(PropTypes.any).isRequired,
  provider: PropTypes.objectOf(PropTypes.any).isRequired,
  payer: PropTypes.objectOf(PropTypes.any).isRequired,
  toggleModal: PropTypes.func.isRequired,
};

DocumentsLinks.propTypes = {
  user: PropTypes.objectOf(PropTypes.any).isRequired,
  toggleModal: PropTypes.func.isRequired,
};
